import {
  OnApproveBraintreeActions,
  OnApproveBraintreeData,
} from "@paypal/react-paypal-js";
import { useCallback } from "react";
import { usePaymentsClientContext } from "../../../../../../contexts/payments-client-context";
import {
  setPaypalData,
  setPaypalError,
  setIsPaypalApproved,
} from "../../../../../../contexts/payments-client-context/state";
import { useAppContext } from "@ftdr/blueprint-components-react";

export type HandleOnApproveActionType = {
  handleOnApproveAction: (
    data: OnApproveBraintreeData,
    actions: OnApproveBraintreeActions
  ) => Promise<void>;
};

export const useHandleOnApproveAction = (): HandleOnApproveActionType => {
  const { dispatch } = usePaymentsClientContext();
  const {
    appSettings: { localizedText },
  } = useAppContext();
  const handleOnApproveAction = useCallback(
    async (data, actions) => {
      try {
        const result = await actions.braintree.tokenizePayment(data);
        dispatch(
          setPaypalData({
            onApproveBraintreeData: data,
            braintreeTokenizePayloadData: result,
          })
        );
        dispatch(setIsPaypalApproved(true));
      } catch (e) {
        dispatch(
          setPaypalError({
            isError: true,
            message: localizedText(`PAYPAL_TOKENIZATION_ERROR`),
          })
        );
      }
    },
    [dispatch, localizedText]
  );

  return { handleOnApproveAction };
};
